import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "./store";

export type ClipboardItemType = "theme" | "subtheme";
export type ClipboardAction = "copy" | "cut";

export interface ClipboardItem {
  id: number;
  name: string;
}

export interface ClipboardState {
  items: ClipboardItem[];
  itemType: ClipboardItemType | null;
  action: ClipboardAction | null;
  /** For cut: numeric ID of the parent context where items were cut from */
  sourceParentId: number | null;
}

const initialState: ClipboardState = {
  items: [],
  itemType: null,
  action: null,
  sourceParentId: null,
};

const clipboardSlice = createSlice({
  name: "clipboard",
  initialState,
  reducers: {
    copyToClipboard: (
      state,
      action: PayloadAction<{
        items: ClipboardItem[];
        itemType: ClipboardItemType;
        sourceParentId?: number;
      }>
    ) => {
      state.items = action.payload.items;
      state.itemType = action.payload.itemType;
      state.action = "copy";
      state.sourceParentId = action.payload.sourceParentId ?? null;
    },
    cutToClipboard: (
      state,
      action: PayloadAction<{
        items: ClipboardItem[];
        itemType: ClipboardItemType;
        sourceParentId: number;
      }>
    ) => {
      state.items = action.payload.items;
      state.itemType = action.payload.itemType;
      state.action = "cut";
      state.sourceParentId = action.payload.sourceParentId;
    },
    clearClipboard: (state) => {
      state.items = [];
      state.itemType = null;
      state.action = null;
      state.sourceParentId = null;
    },
  },
});

export const { copyToClipboard, cutToClipboard, clearClipboard } =
  clipboardSlice.actions;

export const selectClipboard = (state: RootState) => state.clipboard;

export default clipboardSlice.reducer;
